/* istanbul ignore file */
import { parsers } from '@codegrade/utils';
import { DirectoryWithKeyWithChildren } from './DirectoryWithKeyWithChildren';
import { FileTreeWithKeyFileWithKey } from './FileTreeWithKeyFileWithKey';
const FileTreeWithKeyParser = 
/* #__PURE__ */ /* #__PURE__ */ parsers.taggedUnion('type', [
    ['file', FileTreeWithKeyFileWithKey],
    ['directory', DirectoryWithKeyWithChildren],
]);
export const FileTreeWithKey = FileTreeWithKeyParser;
